import { Button } from 'primereact/button';
import { OverlayPanel } from 'primereact/overlaypanel';
import React, { useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';


import { Nav, NavItem } from 'reactstrap';
import { CustomAddPanel, CustomLogin, CustomRegister, CustomSearch } from '../components';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import { useTranslation } from 'react-i18next';

import AuthService from '../security/AuthService';
import CustomAuthLayer from '../components/CustomAuthLayer';



const TopNavigation = (props) => {
    console.log("TopNavigation props ",props);

    const { t } = useTranslation();


    const navigate = useNavigate();

    let { usermail, verificationToken, action } = useParams();

    const opAuth = useRef(null);
    const opLogin = useRef(null);


    const [rightMenuActive, setRightMenuActive] = useState(false);
    let rightMenuClick;



    const [userType, setUserType] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [webSite, setWebSite] = useState('');


    const [companyType, setCompanyType] = useState();
    const [companyName, setCompanyName] = useState('');
    const [title, setTitle] = useState('');
    const [companyWebSite, setCompanyWebSite] = useState('');

    const [address, setAddress] = useState('');

    const [companyTypes, setCompanyTypes] = useState([]);
    const [selectedCompanyType, setSelectedCompanyType] = useState();

    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [passwordConfirm, setPasswordConfirm] = useState('');

    const [showLogin, setShowLogin] = useState(false);

    const toast = useRef(null);

    const [registerVisible, setRegisterVisible] = useState((action === 'verification' ||action === 'reference' ));
    const [loginVisible, setLoginVisible] = useState(false);
    const [searchVisible, setSearchVisible] = useState(false);


    const [contacts, setContacts] = useState([]);
    const [addArtworkVisible, setAddArtworkVisible] = useState((action === 'verification' ||action === 'reference' ));



    const onRightMenuButtonClick = () => {
        rightMenuClick = true;
        setRightMenuActive(true);
    };

    const onRightMenuClick = () => {
        rightMenuClick = true;
    };

    const onRightMenuActiveChange = (active) => {
        setRightMenuActive(active);
    };

    const clear = () => {
        console.log("clear");
        setLoginVisible(false);
        setRegisterVisible(false);
        setSearchVisible(false);
        setAddress("");
        setCompanyName("");
        setCompanyType(null);
        setCompanyTypes([]);
        setCompanyWebSite('');
        setEmail('');
        setFirstName('');
        setLastName('');
        setPassword('');
        setPasswordConfirm('');
        setSelectedCompanyType(null);
        setTitle('');
        setUserName('');
        setUserType('');
        setWebSite('');
    }






    const registerLayer = () => {
        return (
            <Dialog showCloseIcon closeOnEscape dismissable={false} visible={registerVisible} position={'top'} onHide={() => setRegisterVisible(false)} className={'search-dialog'} headerClassName='search-dialog-header' contentClassName='search-dialog-content' >

                <CustomRegister toast={toast} setDialogVisible={setRegisterVisible} {...props}
                    userType={userType} setUserType={setUserType}
                    firstName={firstName} setFirstName={setFirstName}
                    lastName={lastName} setLastName={setLastName}
                    email={email} setEmail={setEmail}

                    webSite={webSite} setWebSite={setWebSite}

                    companyType={companyType} setCompanyType={setCompanyType}
                    companyName={companyName} setCompanyName={setCompanyName}
                    title={title} setTitle={setTitle}
                    companyWebSite={companyWebSite} setCompanyWebSite={setCompanyWebSite}
                    companyTypes={companyTypes} setCompanyTypes={setCompanyTypes}
                    selectedCompanyType={selectedCompanyType} setSelectedCompanyType={setSelectedCompanyType}

                    userName={userName} setUserName={setUserName}
                    password={password} setPassword={setPassword}
                    passwordConfirm={passwordConfirm} setPasswordConfirm={setPasswordConfirm}

                    clear={clear}

                    contacts={contacts} setContacts={setContacts}
                ></CustomRegister>




            </Dialog>

        )


    }

    
   





    const loginLayer = () => {

        return (
            <OverlayPanel ref={opLogin}
                onHide={() => {
                    console.log("onHide", showLogin)
                    setShowLogin(false)
                    setLoginVisible(false);
                }}
                style={{
                    boxShadow: '1px 2px 9px #4C4C4C',
                    maxWidth: 314,
                    borderRadius: 20,
                }}>
                <CustomLogin setDialogVisible={setLoginVisible}
                    toast={toast}
                    clear={clear}
                    op={opLogin}
                ></CustomLogin>


            </OverlayPanel>

        )



    }

    {/*
            <Dialog visible={loginVisible} onHide={() => setLoginVisible(false)} className={'search-dialog'} headerClassName='search-dialog-header' contentClassName='search-dialog-content'>

                <CustomLogin setDialogVisible={setLoginVisible}
                    toast={toast}
                    clear={clear}
                ></CustomLogin>




        </Dialog>*/}

    const authLayer = () => {
        return (
            <OverlayPanel ref={opAuth}
                onHide={() => {
                    console.log("onHide", showLogin)
                    setShowLogin(false)
                }}
                style={{
                    boxShadow: '1px 2px 9px #4C4C4C',
                    maxWidth: 314,
                    borderRadius: 20,
                }}>
                <CustomAuthLayer op={opAuth} toast={toast} 
                />


            </OverlayPanel>

        )


    }

    const searchLayer = () => {
        return (
            <Dialog showCloseIcon closeOnEscape dismissable={false} visible={searchVisible} position={'top'} onHide={() => setSearchVisible(false)} className={'search-dialog'} headerClassName='search-dialog-header' contentClassName='search-dialog-content' >

                <CustomSearch setDialogVisible={setSearchVisible}
                    toast={toast}
                    clear={clear}
                ></CustomSearch>




            </Dialog>

        )


    }

    
    const addArtwork = () => {
        return (
            <Dialog showCloseIcon closeOnEscape dismissable={false} visible={addArtworkVisible} position={'top'} onHide={() => setAddArtworkVisible(false)} className={'search-dialog'} headerClassName='search-dialog-header' contentClassName='search-dialog-content' >

                <CustomAddPanel toast={toast} setDialogVisible={setAddArtworkVisible} {...props}
                    userType={userType} setUserType={setUserType}
                    firstName={firstName} setFirstName={setFirstName}
                    lastName={lastName} setLastName={setLastName}
                    email={email} setEmail={setEmail}

                    webSite={webSite} setWebSite={setWebSite}

                    companyType={companyType} setCompanyType={setCompanyType}
                    companyName={companyName} setCompanyName={setCompanyName}
                    title={title} setTitle={setTitle}
                    companyWebSite={companyWebSite} setCompanyWebSite={setCompanyWebSite}
                    companyTypes={companyTypes} setCompanyTypes={setCompanyTypes}
                    selectedCompanyType={selectedCompanyType} setSelectedCompanyType={setSelectedCompanyType}

                    userName={userName} setUserName={setUserName}
                    password={password} setPassword={setPassword}
                    passwordConfirm={passwordConfirm} setPasswordConfirm={setPasswordConfirm}

                    clear={clear}
                ></CustomAddPanel>




            </Dialog>

        )


    }


    const onLoginClick = (e) => {

        if (AuthService.isLoggedIn()) {
            clear();
            setShowLogin(true);

            opAuth.current.toggle(e);
            //setRightMenuActive(!rightMenuActive);

        } else {
            clear();
            opLogin.current.toggle(e);
            setLoginVisible(true)
        }
    };


    return (
        <div  className='surface-header'>
            <Toast ref={toast} />
         
            <nav className="navbar navbar-expand-md navbar-light sticky-top" role="navigation">

                <div className="container-fluid">
               
                    <a className="navbar-brand" href="/">
                        <img id="topbar-logo" src={`/assets/layout/images/logo-${props.themeColor === 'light' ? 'light' : 'dark'}.png`} alt="vault-layout" className="logo" />

                    </a>
                    <Nav className="ml-auto">
                        <NavItem>
                            {
                                !AuthService.isLoggedIn() &&

                                <div>
                                    <Button label={t('menu_membership')} icon="fas fa-plus" className={registerVisible ? "p-button-rounded mr-2 mb-2" : "p-button-rounded p-button-header mr-2 mb-2"}
                                        onClick={(e) => {
                                            clear();
                                            setRegisterVisible(true);
                                        }}
                                    />
                                    {registerLayer()}
                                </div>
                            }
                            {
                                AuthService.isLoggedIn() &&

                                <div>
                                    <Button label={t('global_btn_add')} icon="pi pi-plus" className={registerVisible ? "p-button-rounded mr-2 mb-2" : "p-button-rounded p-button-header mr-2 mb-2"}
                                        onClick={(e) => {
                                            clear();
                                            setAddArtworkVisible(true);
                                        }}
                                    />
                                    {addArtwork()}
                                </div>
                            }


                        </NavItem>
                        <NavItem>
                            <Button icon="fas fa-search" className={searchVisible ? "p-button-rounded mr-2 mb-2" : "p-button-rounded p-button-header mr-2 mb-2"}
                                onClick={(e) => {
                                    clear();
                                    setSearchVisible(true)
                                    }} />
                            {searchLayer()}

                        </NavItem>
                        <NavItem>
                            <Button icon="fas fa-user-large" className={loginVisible || showLogin ? "p-button-rounded mr-2 mb-2" : "p-button-rounded p-button-header mr-2 mb-2"}
                                onClick={(e) => onLoginClick(e)} >

                            </Button>
                            {loginLayer()}
                            {authLayer()}
                        </NavItem>
                    </Nav>

                </div>
            </nav>


        </div>
    );
};

export default TopNavigation;
